import React, { useState, useEffect, useRef } from 'react'
import styles from './index.module.css'
import TitleAndDesc from '../../components/TitleAndDesc/TitleAndDesc'
import { model, patientCard, token } from '../../assets/const';
import { formatJsonToText } from '../../utils/formatJsonToText';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const Index = () => {
    const {chat} = useSelector(state => state.auth);
    const dispatch = useDispatch();

    const [messages, setMessages] = useState(chat.messages || []); // Храним историю диалога
    const [inputValue, setInputValue] = useState(''); // Текущее введенное сообщение
    const [error, setError] = useState(null);
    const location = useLocation();

    useEffect(() => {
        if (location?.pathname == '/chat/new') {
            dispatch({type:'SET_CHAT', payload: {}});
            setMessages([]);
        }
    }, [location])

    useEffect(() => {
        console.log(messages)
        if (messages?.length == 0) {
            handleSendMessage('first');
        }
    }, [messages])
    
    

    // Создаем реф для контейнера диалога
    const chatHistoryRef = useRef(null);

    // Эффект для автоматической прокрутки вниз
    useEffect(() => {
        if (chatHistoryRef.current) {
            chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
        }
    }, [messages]); // Зависимость от массива сообщений


    const generateGPTResponse = async (userMessage) => {
        try {
            const response = await fetch(
                `https://gpt-proxy.nintegra.ru/v1/chat/completions`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        model: model,
                        messages: [
                            {
                                role: "system",
                                content:
                                    "Ты — вертуальный доктор с уклоном на тему ПТСР" +
                                    "Ты знаешь лучшие книги мира по психологии" +
                                    "Ты обучался в лучших университетах мира на психолога" +
                                    "Ты профессионал в теме ПТСР" +
                                    "Ты должен вести диалог, а не только давать советы сразу" +
                                    // "Поздоровайся в начале диалога" +
                                    "Ты должен должен проявлять поддержку к человеку и стараться его успокоить" +
                                    "Не нужно здороваться второй раз" +
                                    "Продолжай развивать тему и диалог" +
                                    "Не будь слишком добрым и позитивным" +
                                    "Используй тематические смайлы и красивы выводи информацию" +
                                    `Дальше я дам информацию о человеке, который ведет диалог, принимай ее во внимание и используй в помощи:` +
                                    `${formatJsonToText(patientCard)}`
                            },
                            ...messages,
                            { 
                                role: "user", content: userMessage },
                        ],
                        // temperature: 0.3,
                    }),
                }
            );

            if (!response.ok) {
                throw new Error(`GPT API error: ${response.status}, ${await response.text()}`);
            }

            const data = await response.json();
            const content = data?.choices?.[0]?.message?.content || "";

            // Добавляем ответ бота в историю сообщений
            setMessages(prevMessages => [...prevMessages, { role: 'assistant', content }]);
        } catch (err) {
            setError(err.message);
        }
    };

    const handleSendMessage = (type = '') => {
        if (type != 'first') {
            if (inputValue.trim() === '') return;
        }
console.log(type)
        // Добавляем сообщение пользователя в историю
        setMessages(prevMessages => [...prevMessages, { role: 'user', content: inputValue
         }]);
        generateGPTResponse(type == 'first' ? 'Привет' : inputValue); // Отправляем запрос к API
        setInputValue(''); // Очищаем поле ввода
    };

  return (
    <div className={styles.wrapper}>
        <TitleAndDesc title="Новый чат"/>

        <div className={styles.chatContainer}>
                {/* История сообщений */}
                <div 
                ref={chatHistoryRef} // Привязываем реф
                className={styles.chatHistory}>
                    {messages.map((msg, index) => {
                        if (index === 0 && messages[index]?.role == 'user') {
                            return ;
                        } else {
                            return <div key={index} className={msg.role === 'user' ? styles.userMessage : styles.botMessage}>
                                {msg.content}
                            </div>
                        }
                    }
                    )}
                </div>

                {/* Поле ввода сообщения */}
                <div className={styles.chatInput}>
                    <input
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder="Введите сообщение..."
                        onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
                    />
                    <button onClick={handleSendMessage}>Отправить</button>
                </div>
            </div>

    </div>
  )
}

export default Index